import { useEffect, useState } from 'react'
import { IsValidCountry } from './model'

export function useApiIsValidCountry() {
  const [isValidCountry, setIsValidCountry] = useState<IsValidCountry>()

  useEffect(() => {
    ;(async () => {
      try {
        // Always use Mainnet since not chain dependent
        const res = await fetch(`https://api.integral.link/api/v1/ip`)
        const json = await res.json()
        if (json.success) {
          const country = json.data.country
          setIsValidCountry(!!country)
        } else if (json.error == 'Invalid country.') {
          setIsValidCountry(false)
        }
      } catch (err) {
        console.error(err)
      }
    })()
  }, [])

  return isValidCountry
}
